import icon from 'vue-svgicon';

icon.register({
    'regular/book-open-2': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M11.458 21.269a1.6 1.6 0 0 0 1.085 0 13.66 13.66 0 0 1 8.7-.448 1.607 1.607 0 0 0 2.006-1.559V4.928a1.607 1.607 0 0 0-1.12-1.528 13.878 13.878 0 0 0-9.586.2 1.61 1.61 0 0 1-1.085 0 13.881 13.881 0 0 0-9.587-.2A1.607 1.607 0 0 0 .75 4.928v14.334a1.607 1.607 0 0 0 2.006 1.559 13.663 13.663 0 0 1 8.702.448zM12 3.682v17.682" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
